import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgOutlinedClose = forwardRef(
  (props: Props, svgRef: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 24 24"
      ref={svgRef}
      {...props}
    >
      <circle cx={12} cy={12} r={10.5} stroke="currentColor" />
      <path
        fill="#3C3E41"
        fillRule="evenodd"
        d="M7.481 7.481a.96.96 0 011.358 0L12 10.642l3.161-3.16a.96.96 0 011.358 1.357l-3.161 3.16 3.16 3.162a.96.96 0 01-1.357 1.358L12 13.358l-3.161 3.16a.96.96 0 11-1.358-1.357L10.642 12l-3.16-3.161a.96.96 0 010-1.358z"
        className="OutlinedClose_svg__OutlinedClose_svg__symbol"
        clipRule="evenodd"
      />
    </svg>
  )
);
SvgOutlinedClose.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgOutlinedClose;
